import mutations from "./mutations";
import moment from "moment";
import * as actions from "./actions";
import * as getters from "./getters";
import { isValueEmptyProto, cloneObject } from "../../../utils/utils";

const state = {
  quote_list: [],
  web_quote_queue: []
};

state.newSteps = [
  {
    id: 1,
    key: "start_step",
    title: "Customer Information",
    icon_class: "fa fa-search",
    flow_current_step: 1,
    flow_steps: [
      { id: 1, key: "first_last_name" },
      { id: 2, key: "create_update" }
    ],
  },
  {
    id: 2,
    key: "step_quote_my_car",
    title: "Quote my Car",
    icon_class: "fa fa-file-o",
    flow_current_step: 1,
    flow_steps: [
      { id: 1, key: "zip_code" },
      { id: 2, key: "vin" },
      {id: 3, key: "fuelType"}
      //{ id: 4, key: 'damage' },
      //{ id: 3, key: 'parts' },
    ]
  },
  {
    id: 3,
    key: "step_offer",
    title: "Offer",
    icon_class: "fa fa-h-square",
    flow_current_step: 1,
    flow_steps: [{ id: 1, key: "seller_price" }, { id: 2, key: "paq_price" }]
  },
  {
    id: 4,
    key: "step_damage_questions",
    title: "Damage Questions",
    icon_class: "fa fa-hospital-o",
    flow_current_step: 1,
    flow_steps: [{ id: 1, key: "parts" }]
  },
  {
    id: 5,
    key: "step_secondary_offer",
    title: "Offer",
    icon_class: "fa fa-h-square",
    flow_current_step: 2,
    flow_steps: [{ id: 1, key: "seller_price" }, { id: 2, key: "paq_price" }]
  },
  {
    id: 6,
    key: "step_additional_vehicle_info",
    title: "Additional Vehicle Info",
    icon_class: "fa fa-check-square-o",
    flow_current_step: 1,
    flow_steps: [{ id: 1, key: "vehicleRun" }, { id: 2, key: "pickup" }]
  },
  {
    id: 7,
    key: "step_disposition",
    title: "Disposition",
    icon_class: "fa fa-check-square-o",
    flow_current_step: 0,
    flow_steps: []
  },
  {
    id: 8,
    key: "step_proof_of_id",
    title: "Proof of ID",
    icon_class: "fa fa-info",
    flow_current_step: 1,
    flow_steps: [{ id: 1, key: "proof_id" }, { id: 2, key: "proof_ownership" }]
  },
  {
    id: 9,
    key: "step_pickup_information",
    title: "Pickup Information",
    icon_class: "fa fa-calendar-check-o",
    flow_current_step: 0,
    flow_steps: []
  },
  {
    id: 10,
    key: "step_leftout_information",
    title: "Leftout Information",
    icon_class: "fa fa-calendar-check-o",
    flow_current_step: 0,
    flow_steps: []
  },
  {
    id: 11,
    key: "step_vin_check",
    title: "VIN Check",
    icon_class: "fa fa-calendar-check-o",
    flow_current_step: 0,
    flow_steps: []
  },
  {
    id: 12,
    key: "step_agreement",
    title: "Disclosure",
    icon_class: "fa fa-calendar-check-o",
    flow_current_step: 1,
    flow_steps: [{ id: 1, key: "pickup_info" }, { id: 2, key: "documents" }]
  },
  {
    id: 13,
    key: "step_end_call",
    title: "Complete Call",
    icon_class: "fa fa-calendar-check-o",
    flow_current_step: 1,
    flow_steps: [{ id: 1, key: "end_call" }]
  }
];
state.stepEnum = {};
for (const item of state.newSteps) {
  state.stepEnum[item.key] = item.id;
}

state.newQuote = {
  QuoteID: 0,
  CustomerID: 0,
  QuoteStatusTypeID: 1,
  QuoteOriginTypeID: 1,
  WizardStepTypeID: 0,
  CreatedByUserID: 0,
  ModifiedByUserID: 0,
  OwnerByUserID: 0,
  StateProofOfIdentificationID: null,
  MarketID: 1,
  MarketDisplayName: "",
  ProofOfIdentificationTypeID: null
};
state.newCustomer = {
  CustomerID: 0,
  FirstName: "",
  LastName: null,
  PrimaryPhone: "",
  SecondaryPhone: "",
  EmailAddress: ""
};
state.newVehicle = {
  VehicleID: 0,
  QuoteID: 0,
  MakeID: 0,
  Make: "",
  ModelID: 0,
  Model: "",
  ModelYear: 0,
  FuelType: "",
  VIN: null,
  Operable: false, //Change this later
  HasDamage: null,
  HasLien: null,
  SellerPrice: 0,
  Condition: [],
  ConditionDescription: "",
  Enhancement: [],
  Components: [],
  ProofOfOwnershipID: null,
  DocumentRepositoryID: 0,
  TitleNumber: "",
  VehiclePriceAdjustment: 0,
  HasDisqualifyingDamage: null,
  IsActive: true,
  PartsDisplay: "",
  VehicleRun: null,
  HaulFee: 0
};
state.newOffer = {
  VehicleID: 0,
  OfferID: 0,
  SuggestedPrice: 0.0,
  MaxAllowedPrice: 1000.0,
  OfferPrice: 0,
  ZipCode: ""
};
state.newCallInformation = {
  CallInformationID: 0,
  QuoteID: 0,
  CallCodeID: 1,
  CallerIDPhoneID: null,
  CallerIDName: null,
  VoiceSessionID: null
};
state.newQuotePickupLocation = {
  StateID: 0,
  ZipCode: "",
  PickupLocationTypeID: null,
  StreetAddress1: "",
  StreetAddress2: "",
  City: ""
};
state.newQuoteInfo = {
  accepted: false,
  first_decline: false,
  second_decline: false,
  model: null,
  make: null,
  year: null,
  vin: null,
  callback: true,
  status: null,
  extra_info: [],
  missing_parts: [],
  best_contact: "",
  vin_api_info: []
};
state.newFollowup = {
  FollowupID: 0,
  FollowupResultTypeID: 0,
  DateFollowup: null,
  DateRequired: false,
  RequestedFollowup: false
};
state.newQuoteThirdPartyPartner = {
  ThirdPartyPartnerID: 0,
  AssignmentNumber: null,
  QuoteID: 0,
  IsActive: true,
  // Set from the thirdparty=true query string (Verint third party link); no partner ID is supplied
  IsThirdParty: false
};
state.newWizardData = {
  steps: state.newSteps,
  quote: state.newQuote,
  customer: state.newCustomer,
  vehicle: state.newVehicle,
  offer: state.newOffer,
  quotePickupLocation: state.newQuotePickupLocation,
  callInformation: state.newCallInformation,
  mitelInfo: {},
  selectedCallCodeId: 0,
  wizardStepStack: [1],
  currentWizardStep: 1,
  maxWizardStep: 0,
  nextDisabled: false,
  backDisabled: false,
  existingQuoteNumber: "",
  state: 0,
  quote_info: state.newQuoteInfo,
  followup: state.newFollowup,
  followups: [],
  // Follow-up to resolve at disposition when the quote was opened from a search result
  followupID: null,
  // Open quotes found for an outbound call's phone number (PIT-2114 selection widget reads this)
  openQuotes: [],
  skipExitConfirmation: false,
  remoteQuoteID: 0,
  mitelCallerID: {
    callCodeName: "",
    callerName: "",
    callerNumber: "",
    callCodeID: 0
  },
  previousOffers: [],
  partsDisplay: "",
  thirdParty: state.newQuoteThirdPartyPartner,
  verified: false,
  verifiedVINCheck: false
};
Object.freeze(state.newSteps);
Object.freeze(state.stepEnum);
Object.freeze(state.newQuote);
Object.freeze(state.newVehicle);
Object.freeze(state.newCustomer);
Object.freeze(state.newOffer);
Object.freeze(state.newQuotePickupLocation);
Object.freeze(state.newCallInformation);
Object.freeze(state.newQuoteInfo);
Object.freeze(state.newFollowup);
(state.car_model_list = []),
  (state.wizardData = cloneObject(state.newWizardData));
state.quote_state_law = {};

export default {
  state,
  mutations,
  actions,
  getters
};



// WEBPACK FOOTER //
// ./src/store/modules/wizard/index.js